import cx from 'classnames';
import type React from 'react';

type OwnProps = {
  className?: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
};

export default function ClearAll({ className, onClick }: OwnProps) {
  return (
    <button
      type="button"
      className={cx(
        'bg-transparent border-0 cursor-pointer flex items-center p-0 t-body-s text-blue-2 m:t-body-m',
        className
      )}
      onClick={onClick}
      data-analytics-id="Keyword Suggestions - Clear All"
    >
      Clear All
    </button>
  );
}
